import { useSelector } from "react-redux";
import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from "recharts";
import activeitesQuantity from "../../utils/activitiesQuantity";
import theme from "../../config/theme";

export default function RadarChartComponent() {
  const themeMode = useSelector((state: any) => state.globalState.theme);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  const data = activeitesQuantity().filter(
    (item: any) => item.departmentDetailes.isActive !== false
  );
  return (
    <ResponsiveContainer width="100%" height={356}>
      <RadarChart outerRadius={130} data={data}>
        <PolarGrid />
        <PolarAngleAxis
          dataKey="departmentName"
          width={500}
          tick={(props: any) => {
            const { x, y, payload } = props;

            return (
              <text
                x={x}
                y={y}
                textAnchor="middle"
                dominantBaseline="middle"
                style={{
                  direction: "rtl",
                  fontSize: 10,
                  fill: mode.color.textPrimary,
                }}
              >
                {payload.value}
              </text>
            );
          }}
        />

        <Radar
          name="مقالات"
          dataKey="articleQuantity"
          stroke="#8884d8"
          fill="#8884d8"
          fillOpacity={0.6}
        />
        <Radar
          name="اخبار"
          dataKey="newsQuantity"
          stroke="#82ca9d"
          fill="#82ca9d"
          fillOpacity={0.6}
        />
        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  );
}
